import PropertyRow from './PropertyRow';
import { bulkDraftReady, getBulkCheckState } from './groupings';
import { ConfirmAiIcon, PhotosIcon } from './icons';

export default function PropertyGroup({
    group,
    rows,
    groupRef,
    onRowNavigate,
    onRowNavigateEdit,
    onBulkSubmit,
    bulkSubmitting,
    onPlaceholderAction,
    onBulkAddPhotos,
}) {
    const isBulk = group.key === 'bulk_draft';
    const readyCount = isBulk ? rows.filter(bulkDraftReady).length : 0;
    const someUnconfirmed = isBulk && rows.some((r) => getBulkCheckState(r).aiPending > 0);
    const batchLabel = isBulk && rows[0]?.batch ? rows[0].batch : null;

    return (
        <div className="props-group" ref={groupRef} id={group.key === 'bulk_draft' ? 'bulk-draft-group' : undefined}>
            {!group.hideHead && (
            <div className="props-group-head">
                <div className="group-head-meta">
                    <h3>
                        <span className={`group-marker ${group.marker}`} />
                        {group.title}
                    </h3>
                    {isBulk && batchLabel && (
                        <div className="group-head-sub">
                            {batchLabel} · {rows.length} drafts
                        </div>
                    )}
                </div>
                <span className="group-count">{rows.length}</span>
            </div>
            )}

            {rows.map(listing => (
                <PropertyRow
                    key={listing._id}
                    listing={{
                        ...listing,
                        _bulkReady: isBulk ? bulkDraftReady(listing) : false,
                    }}
                    onNavigate={onRowNavigate}
                    onNavigateEdit={onRowNavigateEdit}
                />
            ))}

            {isBulk && (
                <div className="props-group-footer">
                    <div className="footer-summary">
                        <strong>{readyCount} of {rows.length}</strong>
                        {' '}ready to submit · {rows.length - readyCount} still need your input
                    </div>
                    <button
                        type="button"
                        className="bulk-set-defaults-link"
                        onClick={() => onPlaceholderAction('defaults')}
                    >
                        Set defaults for all drafts
                    </button>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => onPlaceholderAction('confirm-ai')}
                        disabled={!someUnconfirmed}
                        title={!someUnconfirmed ? 'No AI fields left to confirm' : undefined}
                    >
                        <ConfirmAiIcon />
                        Confirm all AI fields
                    </button>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={onBulkAddPhotos}
                    >
                        <PhotosIcon />
                        Bulk Add Photos
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        disabled={readyCount === 0 || bulkSubmitting}
                        title={readyCount === 0 ? 'Complete required fields on at least one real draft' : undefined}
                        onClick={() => onBulkSubmit(rows.filter(bulkDraftReady))}
                    >
                        Bulk Submit completed ({readyCount}) →
                    </button>
                </div>
            )}
        </div>
    );
}
